// extracted by mini-css-extract-plugin
export var cardLayout = "_7t-1";
export var paginationContainer = "_7t-0";